import { useAppSelector } from 'application/providers/StoreProvider';

import { useAccountSelectors } from './useAccountSelectors';

export const useAccountCompanyData = () => {
  const selectors = useAccountSelectors();

  const companyData = useAppSelector(selectors.selectMainCompanyData);
  const isBillingEnabled = useAppSelector(selectors.selectCompanyIsBillingEnabled);
  const country = useAppSelector(selectors.selectCompanyCountry);
  const actualContract = useAppSelector(selectors.selectActualContract);

  return {
    companyData,
    isBillingEnabled,
    country,
    actualContract,
  };
};
